export const NOTIFICATION_PAGE_SIZE = 20;
export const NOTIFICATION_SEARCH_MAX = 100;

export const NOTIFICATION_CATEGORIES = [
  { value: 'IMPORTANT_MESSAGES', literal: 'importantMessages' },
  { value: 'MOVEMENTS', literal: 'movements' },
  { value: 'NOTICES', literal: 'notices' },
  { value: 'PROMOTIONS', literal: 'promotions' },
];

export const NOTIFICATION_CATEGORY_VALUES = NOTIFICATION_CATEGORIES
  .map((item) => item.value);
